import { FileInput } from "@mantine/core";
import { useFormProvider } from "../../../providers";

export function DeviceInputComponent() {
  const { data, dispatch } = useFormProvider();

  function handleChange(value: File | null) {
    dispatch({ type: "SET_DATA", key: "device", value });
  }

  return (
    <FileInput
      label="Mesin / Device"
      accept="image/png,image/jpeg"
      value={data.device}
      onChange={handleChange}
      withAsterisk
    />
  );
}
